/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable no-throw-literal */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable prefer-const */
import { Auth } from 'aws-amplify';

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import FormValidator from '../../../../utilities/formValidator';
import useIsDesktop from '../../../../utilities/hooks/useIsDesktop';
import CheckboxInput from '../../../shared/inputs/checkbox-input/checkbox-input';

import PasswordWithConfirm from '../../../shared/blocks/password-with-confirm/password-with-confirm';
import GlobalError from '../../../shared/blocks/global-error/global-error';
import './signup.scss';
import PrimaryButton from '../../../shared/buttons/primary-button/primary-button';

const Signup = () => {
  const formValidator = FormValidator();
  const isDesktop = useIsDesktop();
  const [isSaving, setIsSaving] = useState(false);
  const [formError, setFormError] = useState(null);
  const [matchFormError, setMatchFormError] = useState(null);
  const [showAlmostDone, setShowAlmostDone] = useState(false);
  const [signupEmail, setSignupEmail] = useState('');

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [showAlmostDone]);

  const verifyEmail = async (email) => {
    try {
      const request = await fetch(`https://api.purple.com/api/v3/customer/recipient-validation?email=${encodeURIComponent(email)}`);
      const response = await request.json();
      if (response?.valid === true) {
        return true;
      }
      throw { name: 'InvalidParameterException', message: 'Invalid email address.' };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const emailSubscribe = (email) => {
    const data = {
      listID: 'subscribe_welcome_popup',
      authData: {
        email,
      },
      channels: {
        email,
      },
    };
    window.pubSub?.publish('onEmailSubscribe', data);
  };

  const resendVerificationEmail = async () => {
    try {
      await Auth.resendSignUp(signupEmail);
    } catch (err) {
      formValidator.errorHandling(err);
    }
  };

  const save = async (e) => {
    e.preventDefault();
    const promotionalSignup = document.getElementById('promotionalSignup').checked;
    setIsSaving(true);
    const globalError = document.querySelector('.global-error-box');
    if (!globalError?.classList.contains('d-none')) {
      globalError?.classList.add('d-none');
    }
    try {
      const validateForm = formValidator.formValidate();
      let {
        email,
        newPassword,
        confirmPassword,
        phone_number,
        given_name,
        family_name,
      } = validateForm;

      const username = email;
      if (phone_number === '+1') {
        phone_number = null;
      }

      const password = newPassword;
      const validEmail = verifyEmail(email);
      setSignupEmail(email);

      if (validateForm && validEmail) {
        if (password === confirmPassword) {
          try {
            await Auth.signUp({
              username,
              password,
              attributes: {
                email, // required
                phone_number, // optional - E.164 number convention
                given_name, // optional
                family_name, // optional
                'custom:email_to_be_updated': email,
                // other custom attributes
              },
            });
            sessionStorage.setItem('accountCreated', 'true');
            sessionStorage.setItem('createdAccount', email);

            if (promotionalSignup) {
              emailSubscribe(email);
            }

            setShowAlmostDone(true);
          } catch (error) {
            setIsSaving(false);
            if (error.name === 'LimitExceededException') {
              error.name = 'PasswordLimitExceededException';
            }
            formValidator.errorHandling(error);
            if (error.message.includes('Password')) {
              setFormError(false);
            }
          }
        } else {
          const error = { name: 'PasswordMismatchException', message: 'Passwords do not match' };
          setMatchFormError(false);
          setIsSaving(false);
          formValidator.errorHandling(error);
        }
      }
    } catch (error) {
      setIsSaving(false);
      formValidator.errorHandling(error);
      const passwordContainer = document.querySelector('.password-container');
      if (passwordContainer?.querySelector('.input-error')) setFormError(false);
    }
  };

  return (
    <div className="signup-page bg-white signup mw-s">
      <div className={`${isDesktop ? 'full-border signup' : ''}`}>
        <div className="modal-header m-b-s">
          {showAlmostDone ? <h2 className="ff-wallop fs-h4 c-purple-primary">Almost Done!</h2> :
          <h2 className="ff-wallop fs-h4 c-purple-primary">Create Account</h2>}
        </div>
        <GlobalError />
        <div className="m-b-32">
          {showAlmostDone ? (
            <div className="m-b-40">
              <p className="ff-graphik fw-normal c-light-midnight fs-p1">
                We’ve sent a verification email to
                <span className="signup-email-verification-span">{signupEmail}</span>
                . Just click the link in the email and you are all set!
              </p>
            </div>
          ) : (
            <form className="d-flex flex-column" onSubmit={save}>
              <div className="create-form-container">
                <div className="form-input m-b-16">
                  <label className="fs-p3 ff-graphik m-b-8 c-light-midnight" htmlFor="given_name">First Name</label>
                  <input className="input m-b-8" id="given_name" name="fname" type="text" required aria-label="First Name Required" aria-describedby="firstnameError" />
                  <div className="error warn jsGivenNameExceptionExtra d-none" id="firstnameError" />
                </div>
                <div className="form-input m-b-16">
                  <label className="fs-p3 ff-graphik m-b-8 c-light-midnight" htmlFor="family_name">Last Name</label>
                  <input className="input m-b-8" id="family_name" name="lname" type="text" required aria-label="Last Name Required" aria-describedby="lastnameError" />
                  <div className="error warn jsFamilyNameExceptionExtra d-none" id="lastnameError" />
                </div>
                <div className="form-input m-b-16">
                  <label className="fs-p3 ff-graphik m-b-8 c-light-midnight" htmlFor="email">Email</label>
                  <input className="input m-b-8" id="email" name="email" type="email" required aria-describedby="emailError" aria-label="Email Required" />
                  <div className="error warn jsAuthErrorEmailExtra jsInvalidParameterEmailExceptionExtra jsEmailExceptionExtra jsUsernameExistsExceptionExtra d-none" data-testid="emailError" id="emailError" />
                </div>
                <div className="form-input m-b-16">
                  <label className="fs-p3 ff-graphik m-b-8 c-light-midnight" htmlFor="phone_number">Phone Number</label>
                  <input className="input m-b-8" id="phone_number" name="phone" type="tel" data-testid="phone_number" required aria-label="Phone Number Required" aria-describedby="phoneError" />
                  <div className="error warn jsInvalidParameterPhoneNumberExceptionExtra jsPhoneNumberExceptionExtra d-none" id="phoneError" />
                </div>
                <div className="password-container input-container d-flex flex-column">
                  <PasswordWithConfirm
                    lengthPasswordError={formError}
                    matchPasswordError={matchFormError}
                    inputId="newPassword"
                    inputName="newPassword"
                    label="Password"
                    confirmInputId="confirmPassword"
                    confirmInputName="confirmPassword"
                    confirmLabel="Confirm Password"
                    passwordException="jsNewPasswordExceptionExtra"
                    confirmPasswordException="jsConfirmPasswordExceptionExtra"
                  />
                </div>

              </div>
              <div className="promotional-check m-b-s m-t-16">
                <CheckboxInput checkboxId="promotionalSignup" checkboxName="promotionalSignup" checkMessage="Sign up for exclusive email promotions" defaultChecked />
                <span className="terms-policy-text ff-graphik c-light-midnight fs-p3">
                  By clicking 'Sign up now' you represent that you are at least 18 years of age and have read, understand, and agree to be bound by Purple's Customer Program Terms and Conditions
                  <a href="/terms-and-privacy" className="ff-graphik-medium fw-normal c-purple-medium td-underline located-here-link" rel="noreferrer" target="_blank">located here</a>
                  .
                  To see how we may use your information, please take a look at our
                  <a href="/terms-and-privacy#pprivacy-policyp" className="ff-graphik-medium fw-normal c-purple-medium td-underline privacy-policy-link" rel="noreferrer" target="_blank">Privacy Policy</a>
                  .
                </span>
              </div>
              <PrimaryButton
                onClick={save}
                isLoading={isSaving}
                title="Create Account"
                buttonType="submit"
              />
            </form>
          )}
        </div>
        <div className="ff-graphik fw-normal">
          {showAlmostDone ? (
            <p className="ff-graphik fw-normal fs-p2">
              Didn't receive a verification email?
              <span onClick={resendVerificationEmail} className="sign-in-link pointer td-underline c-purple-medium fw-normal ff-graphik-medium">Resend</span>
            </p>
          ) : (
            <p className="ta-center ff-graphik fw-normal fs-p2">
              Already have an account?
              <Link to="/login" className="sign-in-link td-underline c-purple-medium fw-normal ff-graphik-medium">Sign In</Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default Signup;
